import { render } from "./Reports_backup.vue?vue&type=template&id=11557004"
import script from "./Reports_backup.vue?vue&type=script&lang=js"
export * from "./Reports_backup.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/lf.m2geo.ie/releases/20261103161156/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Task/Partials/Reports_backup.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "11557004"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('11557004', __exports__)) {
    console.log('reload')
    api.reload('11557004', __exports__)
  }
  
  module.hot.accept("./Reports_backup.vue?vue&type=template&id=11557004", () => {
    console.log('re-render')
    api.rerender('11557004', render)
  })

}


export default __exports__